import React from 'react';
type LogoProps = {
  className?: string;
};
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/2bV2zTjJvTLKwNdHEvcDyJ/Screenshot_2026-09-24_at_9.16.02_PM.png';

// Clip the uploaded screenshot to the logo silhouette so stray page content is hidden.
const LOGO_CLIP = 'polygon(19.8% 9.6%, 42.3% 13.6%, 40.1% 24.9%, 47.3% 25.2%, 48.4% 24.6%, 49.5% 14.1%, 71.4% 14.1%, 75.8% 18.5%, 93.4% 91.2%, 1.6% 92%, 2.4% 89%)';
export function Logo({
  className = ''
}: LogoProps) {
  return <img src={LOGO_URL} alt="Hondurans in LA" className={`block h-auto select-none ${className}`} style={{
    clipPath: LOGO_CLIP
  }} draggable={false} data-id="element-190" data-mp="rsh54ke6jpp9" />;
}